import Cookies from 'js-cookie';
import { create } from 'zustand';

export default create((set) => ({
    auth_token: Cookies.get('token'),
    setSiteConfig: (siteConfig) => set(() => ({ siteConfig })),
}));
